import { j as e } from "../../../jsx-runtime-B3iL8JI7.js";
import { useRef as k, useImperativeHandle as T } from "react";
import { textFieldStyles as C } from "./TextField.styles.js";
import { leftIconOptions as F } from "./TextField.consts.js";
import H from "./subcomponents/RightCTA.js";
import O from "../../subcomponents/formHelpers/HelperText/HelperText.js";
import $ from "../Icon/Icon.js";
import A, { getErrorId as B } from "../../subcomponents/formHelpers/ErrorText/ErrorText.js";
import M from "../../subcomponents/formHelpers/OptionalText/OptionalText.js";
import h from "../../subcomponents/formHelpers/InputLabel/InputLabel.js";
import i from "../../../tailwindConfig/bclTwMerge.js";
const _ = ({
  className: u,
  disabled: n,
  displayOnly: p,
  errorText: s = "",
  helperIcon: f,
  helperText: x,
  id: t,
  inputRef: j,
  label: a,
  leftIcon: l,
  required: c,
  rightCta: r,
  autoComplete: y = "on",
  "aria-live": S,
  ...b
}) => {
  const o = k(null);
  T(j, () => o.current);
  const {
    inputWrapperDisabled: w,
    inputWrapperDisplayOnly: W,
    inputWrapperError: d,
    inputWrapper: v,
    inputBase: D,
    wrapper: E
  } = C, I = i(E), L = i(D), N = i(
    v,
    s && d,
    (n || p) && w,
    p && W,
    u
  ), R = () => {
    var m;
    (m = o.current) == null || m.focus();
  };
  return /* @__PURE__ */ e.jsxs("div", { className: I, children: [
    a && /* @__PURE__ */ e.jsx(
      h,
      {
        id: t,
        label: a,
        isDisplayOnly: p,
        showDisabled: n,
        showErrorState: !!s
      }
    ),
    /* @__PURE__ */ e.jsxs(
      "div",
      {
        role: "none",
        className: N,
        onClick: () => R(),
        "data-testid": `${t}-input-wrapper`,
        children: [
          l && /* @__PURE__ */ e.jsx(
            $,
            {
              icon: F[l],
              "data-testid": `${t}-left-icon`
            }
          ),
          /* @__PURE__ */ e.jsx(
            "input",
            {
              className: L,
              disabled: n || p,
              id: t,
              ref: o,
              required: c,
              autoComplete: y,
              "aria-describedby": B(t),
              "aria-invalid": s ? !0 : void 0,
              ...b
            }
          ),
          r && /* @__PURE__ */ e.jsx(
            H,
            {
              id: t,
              type: r.type,
              content: r.content,
              iconLabel: r.iconLabel,
              className: r.className,
              onClick: r.onClick
            }
          )
        ]
      }
    ),
    /* @__PURE__ */ e.jsx(O, { id: t, helperText: x, helperIcon: f }),
    !c && /* @__PURE__ */ e.jsx(M, { id: t }),
    /* @__PURE__ */ e.jsx(A, { id: t, text: s, ariaLive: S })
  ] });
};
export {
  _ as default
};
